export default {
    getAllRemotes: () => {
        return {
            url: '/myfhe/remotes',
            method: 'GET'
        };
    },
    getRemoteDetails: remoteId => {
        return {
            url: '/myfhe/remotes/:remoteId',
            method: 'GET',
            route_params: {
                remoteId
            }
        };
    }
};



// WEBPACK FOOTER //
// ./environments/myfhe/data/Remote/api.js